import { createEvent, sample, type EventCallable } from 'effector'
import { SignUpEntryPoint } from '~/shared/analytics/index.h'
import { model as signInModel } from '~/widgets/auth/sign-in'
import { model as signUpModel } from '~/widgets/auth/sign-up'

export const signUpClicked: EventCallable<SignUpEntryPoint> = createEvent()
export const signInClicked: EventCallable<SignUpEntryPoint> = createEvent()

sample({
  clock: signUpClicked,
  target: signUpModel.openSignUpPopup,
})

sample({
  clock: signInClicked,
  target: signInModel.openSignInPopup,
})
